import { Box } from '@mui/material';
import { GridColDef, DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { getCVUploadAnalyticsDetails } from 'wisestep-api';
import { WsTypography, WsColors } from 'wisestep-base';

interface TableData {
  id: string;
  cvUploadCount: number;
}

const CVUploadRecord = ({ payload, hour }) => {
  const paginationSize = 10;
  const [tableData, setTableData] = useState<TableData[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      payload.timeDifference = hour;
      const response = await getCVUploadAnalyticsDetails(payload);
      const aggregatedData = response.data.reduce((acc, curr) => {
        const workspaceName = curr.workspaceName;
        const uploadedCount = curr.uploadedCount;
        acc[workspaceName]
          ? (acc[workspaceName].cvUploadCount += uploadedCount)
          : (acc[workspaceName] = { id: workspaceName, cvUploadCount: uploadedCount });
        return acc;
      }, {});

      const transformedData = Object.values(aggregatedData) as TableData[];
      setTableData(transformedData);
    };
    fetchData();
  }, [payload, hour]);

  const sum = tableData.reduce((acc, curr) => acc + curr.cvUploadCount, 0);

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'Workspace Name', flex: 2 },
    {
      field: 'cvUploadCount',
      headerName: `local(${sum})`,
      flex: 1,
    },
  ];

  return (
    <Box>
      <WsTypography>{`CV Upload Source - ${hour} hour`}</WsTypography>
      <Box style={{ height: 600, background: WsColors.White }}>
        <DataGrid
          columns={columns}
          rows={tableData}
          components={{ Toolbar: GridToolbar }}
          pageSize={paginationSize}
          rowsPerPageOptions={[paginationSize]}
        />
      </Box>
    </Box>
  );
};

export default CVUploadRecord;
